import { Paper, styled } from '@material-ui/core';

export const SectionCard = styled(Paper)({
  maxWidth: '900px',
  marginTop: '53px',
  boxShadow: '0px 0px 10px 0.25px rgba(0,0,0,0.1)',
});
